import gql from 'graphql-tag';
import { billingDetailsGQLFields } from './billingDetails.fields.js';
export const billingDetailsGQLQuery = () => gql `
  query BillingDetails {
    billingDetails {
      ${billingDetailsGQLFields()}
    }
  }
`;
export const invoicesGQLQuery = () => gql `
  query Invoices {
    invoices {
      total
      status
      invoiceUrl
      date
      currency
      cardLastFourDigits
    }
  }
`;
export const vatTypesGQLQuery = () => gql `
  query VatTypes {
    vatTypes {
      key
      placeholder
      text
      value
    }
  }
`;
export const purchaseGQLMutation = () => gql `
  mutation Purchase($input: PurchaseInput!) {
    purchase(input: $input) {
      createdAt
      id
      status
      updatedAt
    }
  }
`;
export const updateBillingDetailsGQLMutation = () => gql `
  mutation UpdateBillingDetails($input: BillingDetailsInput!) {
    updateBillingDetails(input: $input) {
      ${billingDetailsGQLFields()}
    }
  }
`;
export const basketsGQLQuery = () => gql `
  query Baskets($input: BasketsInput!) {
    baskets(input: $input) {
      promoErrorMessage
      items {
        promoCodeItem
        note
        title
        value {
          currency
          formattedValue
          value
        }
      }
      renewalType
      total {
        currency
        formattedValue
        value
      }
    }
  }
`;
//# sourceMappingURL=billing.gql.js.map